import { LitElement } from 'lit';
import { getBootstrapStyles, getBootstrapIconsStyles } from './styles.js';

/**
 * Base component that includes Bootstrap styles in Shadow DOM.
 * Extend this class for all RPGish components.
 */
export class BaseComponent extends LitElement {
    async connectedCallback() {
        super.connectedCallback();

        // Adopt Bootstrap and Bootstrap Icons stylesheets into this component's shadow root
        const [bootstrapSheet, iconsSheet] = await Promise.all([
            getBootstrapStyles(),
            getBootstrapIconsStyles()
        ]);

        if (this.shadowRoot) {
            const existingSheets = this.shadowRoot.adoptedStyleSheets;
            const sheetsToAdd = [];

            if (!existingSheets.includes(bootstrapSheet)) {
                sheetsToAdd.push(bootstrapSheet);
            }
            if (!existingSheets.includes(iconsSheet)) {
                sheetsToAdd.push(iconsSheet);
            }

            if (sheetsToAdd.length > 0) {
                this.shadowRoot.adoptedStyleSheets = [
                    ...sheetsToAdd,
                    ...existingSheets
                ];
            }
        }
    }
}
